import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function Level2Detail() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-304">
      <div className="max-w-5xl mx-auto" data-id="element-305">
        <div className="text-center mb-12" data-id="element-306">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-4" data-id="element-307">
            Sistema Carrera Organizada™
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-308">
            Todo el Megapack más los tomos clínicos de Guardia y Medicina
            Interna para los años más exigentes de la carrera.
          </p>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 shadow-sm mb-12 overflow-hidden max-w-3xl mx-auto" data-id="element-309">
          <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between bg-slate-100 hover:bg-slate-200 transition-colors" data-id="element-310">
            <span className="font-bold text-slate-800 flex items-center gap-2" data-id="element-311">
              <span data-id="element-312">✅</span> Ya incluye todo el Nivel 1
            </span>
            {isOpen ? <ChevronUp size={20} className="text-slate-500" data-id="element-313" /> : <ChevronDown size={20} className="text-slate-500" data-id="element-314" />}
          </button>

          {isOpen && <div className="px-6 py-4 border-t border-slate-200 flex flex-wrap gap-6 bg-white" data-id="element-315">
              <div className="flex items-center gap-2 font-medium text-slate-700" data-id="element-316">
                <span data-id="element-317">📚</span> 6 Tomos
              </div>
              <div className="flex items-center gap-2 font-medium text-slate-700" data-id="element-318">
                <span data-id="element-319">🎁</span> 6 Bonos
              </div>
            </div>}
        </div>

        <div className="mb-8 text-center" data-id="element-320">
          <div className="inline-block font-bold text-brand-amber text-lg mb-2" data-id="element-321">
            ⭐ Lo nuevo en este nivel
          </div>
          <div className="inline-block bg-brand-blue text-white text-sm font-bold px-3 py-1 rounded-full ml-3" data-id="element-322">
            2 Tomos clínicos
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16" data-id="element-323">
          <div className="bg-white rounded-xl p-6 border-2 border-brand-blue shadow-md flex gap-4" data-id="element-324">
            <div className="text-4xl shrink-0" data-id="element-325">🚨</div>
            <div data-id="element-326">
              <div className="inline-block bg-brand-blue text-white text-xs font-bold px-2 py-1 rounded mb-2" data-id="element-327">
                Tomo 07
              </div>
              <h4 className="font-bold text-slate-900 mb-2" data-id="element-328">
                Guardia y Emergencias para el Estudiante
              </h4>
              <p className="text-sm text-slate-600" data-id="element-329">
                Las 10 consultas más frecuentes, abordaje de dolor abdominal,
                disnea, fiebre, shock y cómo presentar un paciente al médico.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border-2 border-brand-blue shadow-md flex gap-4" data-id="element-330">
            <div className="text-4xl shrink-0" data-id="element-331">🩺</div>
            <div data-id="element-332">
              <div className="inline-block bg-brand-blue text-white text-xs font-bold px-2 py-1 rounded mb-2" data-id="element-333">
                Tomo 08
              </div>
              <h4 className="font-bold text-slate-900 mb-2" data-id="element-334">
                Medicina Interna para el Examen
              </h4>
              <p className="text-sm text-slate-600" data-id="element-335">
                HTA, diabetes, insuficiencia cardíaca, EPOC, IRC, anemia y los
                casos clínicos más frecuentes en los finales.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-336">
          <p className="text-lg italic text-slate-500 mb-2" data-id="element-337">
            ¿Querés la versión completa?
          </p>
          <div className="text-slate-400 text-2xl animate-bounce" data-id="element-338">↓</div>
        </div>
      </div>
    </section>;
}